import type {
  TariffType,
  TariffTypeApi,
  TariffTypeFilters,
  TariffTypeFiltersUpdateApi,
  TariffTypes,
  TariffTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

const ALLOWED_TARIFF_TYPE_STRING2 = new Set(['TB', 'PB']);
const EXCLUDED_TARIFF_TYPE_CODE_IDS = new Set(['AHW', 'A1W', 'A5W', 'A10', 'A20', 'A30']);

const isAllowedTariffType = (tariffType: TariffTypeApi): boolean => {
  const string2 = tariffType.string2?.toUpperCase();
  const codeId = tariffType.codeId?.toUpperCase();

  return Boolean(
    string2 && ALLOWED_TARIFF_TYPE_STRING2.has(string2) && (!codeId || !EXCLUDED_TARIFF_TYPE_CODE_IDS.has(codeId)),
  );
};

export const normalizeTariffType = (tariffType: TariffTypeApi): TariffType => ({
  ...tariffType,
  id: tariffType.codeId ?? String(tariffType.id),
  label: tariffType.codeDesc,
});

export const normalizeTariffTypes = (response: TariffTypesApi): TariffTypes => {
  const list = (response.items ?? [])
    .filter(isAllowedTariffType)
    .sort((a, b) => a.codeDesc.localeCompare(b.codeDesc))
    .map(normalizeTariffType);
  return {
    list,
    map: list.reduce(
      (acc, tariffType) => {
        acc[String(tariffType.id)] = tariffType;
        return acc;
      },
      {} as TariffTypes['map'],
    ),
  };
};

export const normalizeTariffTypeFilters = (filters: Partial<TariffTypeFilters>): TariffTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
